// Moderation action identifiers used for permission checks.
// Keys are the API dot-notation format. Values are the frontend subject/action used with CASL.
// In templates, pass keys to ModerationContext :actions prop.
// In ability checks, use: abilities.can(action, subject)

export const MODERATION_ACTIONS = {
    'chat.message.create': { subject: 'chat.message', action: 'create' },
    'chat.message.edit': { subject: 'chat.message', action: 'edit' },
    'chat.message.reply': { subject: 'chat.message', action: 'reply' },
    'chat.message.vote': { subject: 'chat.message', action: 'vote' },
    'chat.topic.create': { subject: 'chat.topic', action: 'create' },
    'chat.channel.create': { subject: 'chat.channel', action: 'create' },
    'chat.channel.edit': { subject: 'chat.channel', action: 'edit' },
    'game.challenge.create': { subject: 'game.challenge', action: 'create' },
    'game.idea.enter': { subject: 'game.idea', action: 'enter' },
    'game.mentor_comment.create': { subject: 'game.mentor_comment', action: 'create' },
    'game.rate': { subject: 'game', action: 'rate' },
    'account.signin': { subject: 'account', action: 'signin' },
    'account.profile.edit': { subject: 'account.profile', action: 'edit' },
    'payment.withdraw': { subject: 'payment', action: 'withdraw' },
    'notification.dailydigest': { subject: 'notification', action: 'dailydigest' },
}
